














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class LogoutIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '18' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
